import React, { useEffect, useState } from 'react';
import '../styles/ModalAuto.css';

function ModalAuto() {
    const [show, setShow] = useState(false);
    const [showVideo, setShowVideo] = useState(false);

    const MODAL_CLOSE_TIME_KEY = 'modalCloseTime';
    const MODAL_DISPLAY_INTERVAL = 24 * 60 * 60 * 1000; // 1 día en milisegundos

    useEffect(() => {
        const lastCloseTime = localStorage.getItem(MODAL_CLOSE_TIME_KEY);
        const now = new Date().getTime();

        if (!lastCloseTime || now - lastCloseTime > MODAL_DISPLAY_INTERVAL) {
            setShow(true);
        }
    }, [MODAL_DISPLAY_INTERVAL]);

    useEffect(() => {
        if (show) {
            // Bloquea scroll del fondo
            document.body.style.overflow = 'hidden';
        } else {
            // Restaura el scroll
            document.body.style.overflow = 'auto';
        }

        // Cleanup por seguridad al desmontar componente
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [show]);

    const handleClose = () => {
        setShow(false);
        setShowVideo(false);
        localStorage.setItem(MODAL_CLOSE_TIME_KEY, new Date().getTime());
    };

    return (
        <>
            {show && (
                <div className="custom-overlay" onClick={handleClose}>
                    <div className="custom-overlay-content" onClick={(e) => e.stopPropagation()}>

                        <button
                            className="close-btn"
                            onClick={handleClose}
                            aria-label="Cerrar"
                        >
                            ✕
                        </button>

                        {!showVideo ? (
                            <>
                                <picture>
                                    <source
                                        srcSet="https://imagenes-tubisnez.s3.us-east-2.amazonaws.com/utils/how-order-web.webp"
                                        type="image/webp"
                                    />

                                    <img
                                        src="https://imagenes-tubisnez.s3.us-east-2.amazonaws.com/utils/how-order-web.webp"
                                        alt="Cómo comprar"
                                        className="img-fluid rounded shadow-sm"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </picture>

                                <button
                                    className="tutorial-btn"
                                    onClick={() => setShowVideo(true)}
                                >
                                    ▶ Ver tutorial
                                </button>
                            </>
                        ) : (
                            <>
                                <div className="tutorial-video-container">
                                    <video
                                        controls
                                        autoPlay
                                        playsInline
                                        preload="metadata"
                                        className="tutorial-video"
                                    >
                                        <source
                                            src="https://imagenes-tubisnez.s3.us-east-2.amazonaws.com/utils/tutorial.mp4"
                                            type="video/mp4"
                                        />
                                    </video>
                                </div>

                                <button
                                    className="tutorial-btn secondary"
                                    onClick={() => setShowVideo(false)}
                                >
                                    ← Volver a la imagen
                                </button>
                            </>
                        )}

                    </div>
                </div>
            )}
        </>
    );
}

export default ModalAuto;
